import { ajax } from '../../../services/helper'
class ApiService {

    getDepartmentTeamsData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/departmentTeams/list"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    addDepartmentTeams = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/departmentTeams/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getDepartmentTeamsById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/departmentTeams/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    editDepartmentTeams = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/departmentTeams/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getDepartmentsDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/departments/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }    

    getEmployeesListData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }    

    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Department Teams/services/apiservices.js